import { SectionModel } from "./models-index";

export type ContentType = 'Html' | 'Number' | 'String' | 'File' | 'Section' | 'Video';
export type ContentValueType = string | number | File;

export interface ContentModel {
  type: ContentType;
  id?: number;
  created?: Date;
  createdBy?:   string;
  name:        string;
  isActive?:    boolean;
  tags?: string[];
  description?: string;
  value: ContentValueType;
  order: number;
  sectionId: number;
}

export interface HtmlContentModel extends ContentModel {
  html: string;
  sectionId: number;
}

export interface StringContentModel extends ContentModel {
  string: string;
  sectionId: number;
}

export interface NumberContentModel extends ContentModel {
  number: number;
  sectionId: number;
}

export interface FileContentModel extends ContentModel {
  file: File;
  thumbnail: File;
  sectionId: number;
  fileName?: string;
  thumbnailFileName?: string;
}

export interface SectionContentModel extends ContentModel {
  order: number;
}

export interface PopupData {
  content: ContentModels;
  existingSections: Array<SectionModel>;
}

export interface ContentFileInformationModel {
  fileName: string;
  fileUrl: string;
  thumbnailFileName: string;
  thumbnailFileUrl: string;
}

export type ContentModels = HtmlContentModel | StringContentModel | NumberContentModel | FileContentModel;

export const getContentValue = (content: ContentModels): string | number | File => {
  switch (content?.type) {
    case 'Html':
      return (content as HtmlContentModel).html;
    case 'Number':
      return (content as NumberContentModel).number;
    case 'String':
      return (content as StringContentModel).string;
    case 'File':
      return (content as FileContentModel).file;
    default:
      return null;
  }
};
